export const topicDetails = [
  {
    id: "music-festival-video",
    summary:
      "一段音乐节现场短视频在多个账号间被反复转发，画面顺序与前后的音频出现错位。我们比对了三位现场观众拍摄的原始素材，梳理出剪辑发生在哪一步。",
    timeline: [
      { time: "08-24 20:10", title: "现场演出开始", desc: "观众拍摄的首段素材入库，画面包含舞台主屏与人群。", source: "现场观众A" },
      { time: "08-25 09:30", title: "首条短视频发布", desc: "某账号发布20秒片段，剪辑点为歌曲第一段副歌。", source: "平台公开帖" },
      { time: "08-26 11:00", title: "二次转发修改时长", desc: "转发版本被裁成9秒，音频前移约0.8秒，造成口型错位。", source: "多账号转发" },
      { time: "08-28 16:00", title: "当事人回应", desc: "当事账号发布完整片段并说明现场情况。", source: "官方账号" },
      { time: "09-06 10:00", title: "复核完成", desc: "三段原始素材可拼合出完整歌曲顺序，剪辑点被确认。", source: "本站复核" },
    ],
    evidence: [
      { type: "视频素材", title: "现场观众原始片段x3", desc: "三段素材拍摄角度不同，但音频轨完全一致，可作为基准参照。", weight: "强", source: "观众提供" },
      { type: "音频比对", title: "音频波形对齐", desc: "转发版本音频比原素材提前约0.8秒，形成视觉错位。", weight: "强", source: "本站分析" },
      { type: "截图", title: "转发链截图", desc: "记录了从首发到扩散的完整转发路径与时间。", weight: "中", source: "平台公开信息" },
      { type: "文字", title: "当事方说明", desc: "对现场流程作出解释，与素材时间线基本一致。", weight: "中", source: "公开声明" },
    ],
    credible: [
      "三段不同角度的原始素材在时间轴上可以互相拼合，歌曲段落顺序一致。",
      "转发版本的音频相对原始素材整体提前约0.8秒，属可测量的偏差。",
      "首发账号与转发账号的发布时间差与截图记录吻合。",
    ],
    disputed: [
      "转发者的主观动机无法从素材本身判断。",
      "部分更早的短视频已难以找到原始发布记录。",
    ],
    verdict:
      "现有的三段原始素材支持「转发过程中出现音频前移」这一结论，画面错位属于剪辑带来的技术性失真，而非现场真实情况。事件仍在追证中，如有新的现场素材会继续更新。",
  },
  {
    id: "brand-live-price",
    summary:
      "有观众反映某场直播中商品价格在开播后被上调。我们抓取了同一商品的页面快照与直播回放时间轴，确认改价确实发生在开播后第七分钟。",
    timeline: [
      { time: "08-18 19:00", title: "直播开播", desc: "页面快照显示商品标价与预告一致。", source: "页面快照" },
      { time: "08-18 19:07", title: "价格发生变动", desc: "同一商品链接标价上调，库存提示同步刷新。", source: "页面快照" },
      { time: "08-19 10:00", title: "观众反馈集中出现", desc: "多个账号发布下单截图，价格不一致。", source: "平台公开帖" },
      { time: "08-20 15:00", title: "商家说明", desc: "商家称属于活动档位切换，并非临时抬价。", source: "公开声明" },
      { time: "09-04 12:00", title: "复核完成", desc: "两次快照与回放时间轴可相互印证改价时点。", source: "本站复核" },
    ],
    evidence: [
      { type: "页面快照", title: "改价前快照", desc: "记录了开播时的商品标价与活动文案。", weight: "强", source: "公开页面存档" },
      { type: "页面快照", title: "改价后快照", desc: "同一商品链接在七分钟后标价发生变化。", weight: "强", source: "公开页面存档" },
      { type: "视频回放", title: "直播回放时间轴", desc: "回放中主持人提及价格的时间点与快照变更一致。", weight: "强", source: "平台回放" },
      { type: "截图", title: "下单记录", desc: "不同用户下单价格存在差异。", weight: "中", source: "用户提供" },
    ],
    credible: [
      "改价前后两次页面快照的商品编号一致，可以确定为同一条链接。",
      "直播回放中主持人口述的时间点，与快照变更时间误差在两分钟以内。",
      "多位用户的下单记录呈现两种不同价格。",
    ],
    disputed: [
      "活动档位切换是否提前告知，双方说法仍不一致。",
    ],
    verdict:
      "改价这一事实可由页面快照与回放时间轴相互印证，判定为已核实。至于是否构成价格误导，需要结合活动规则原文进一步判断，本站仅呈现依据。",
  },
  {
    id: "chat-record-leak",
    summary:
      "一组标注为「内部聊天记录」的截图在小范围流传。截图存在两处字体基线与消息排序异常，目前无法确认其来源，暂列为存疑。",
    timeline: [
      { time: "08-29 22:00", title: "截图首次出现", desc: "在小型社群中被转发，未注明来源。", source: "社群截图" },
      { time: "09-01 14:00", title: "开始大范围扩散", desc: "多个账号以不同标题转发同一组图片。", source: "平台公开帖" },
      { time: "09-03 11:00", title: "出现质疑声", desc: "有用户指出时间戳与排序不一致。", source: "平台评论" },
      { time: "09-08 16:00", title: "仍无法溯源", desc: "未找到原始发布者，截图元信息已被清理。", source: "本站复核" },
    ],
    evidence: [
      { type: "截图", title: "流传截图x4", desc: "四张图片的边框宽度存在细微差异。", weight: "中", source: "公开转发" },
      { type: "字体比对", title: "字体基线检查", desc: "两处文字的基线与同版本客户端存在偏移。", weight: "中", source: "本站分析" },
      { type: "元信息", title: "文件信息", desc: "主流传图片均已被二次压缩，缺少原始元信息。", weight: "弱", source: "文件检查" },
    ],
    credible: [
      "四张截图在边框与压缩痕迹上存在差异，说明并非一次性导出。",
    ],
    disputed: [
      "字体基线偏移可能来自截图缩放，无法据此判定为伪造。",
      "文件元信息缺失，无法确认截图生成设备与时间。",
      "没有任何一方出面确认截图的真实性。",
    ],
    verdict:
      "目前既不能证实也不能证伪，判定为存疑。在来源得到确认之前，建议不要把截图内容当作已成立的事实传播。",
  },
  {
    id: "charity-donation",
    summary:
      "网传某次公益活动的捐赠金额与实际公示存在差额。我们对照公开的捐赠公示页面与活动方说明，差额来自统计口径不同，并非遗漏。",
    timeline: [
      { time: "08-08 10:00", title: "活动公示发布", desc: "公示页面上线，列出分类捐赠明细。", source: "公示页面" },
      { time: "08-10 20:00", title: "差额质疑出现", desc: "有用户对比不同页面后指出金额不一致。", source: "平台公开帖" },
      { time: "08-15 09:00", title: "活动方说明口径", desc: "说明不同页面分别统计物资与现金。", source: "公开声明" },
      { time: "08-30 15:00", title: "复核完成", desc: "两套数据在合并后可以对齐。", source: "本站复核" },
    ],
    evidence: [
      { type: "公示数据", title: "现金捐赠明细", desc: "公示页面中的现金类汇总数据。", weight: "强", source: "公示页面" },
      { type: "公示数据", title: "物资捐赠明细", desc: "另一页面中的物资折价统计。", weight: "强", source: "公示页面" },
      { type: "说明", title: "活动方口径说明", desc: "解释了两次统计的范围差异。", weight: "中", source: "公开声明" },
    ],
    credible: [
      "现金与物资两套明细在合并后总额可以对齐，差额可被解释。",
      "两个公示页面的统计时间范围不同，这一点在页面说明中有标注。",
    ],
    disputed: [
      "物资折价的评估标准未公开，无法逐项复核。",
    ],
    verdict:
      "差额来源于现金与物资分开统计，并非数据遗漏，判定为已核实。信息公开的颗粒度仍有改进空间，这一点已在页面上标注。",
  },
  {
    id: "award-backstage-audio",
    summary:
      "一段疑似后台对话的录音被放出，音频存在明显的降噪与环境音缺失。我们对比了同场活动的公开直播音轨，给出目前的判断依据。",
    timeline: [
      { time: "08-22 23:00", title: "录音首次出现", desc: "以短音频形式在社群流传，未附带出处。", source: "社群音频" },
      { time: "08-24 12:00", title: "扩散到公开平台", desc: "被配以字幕形式传播。", source: "平台公开帖" },
      { time: "08-27 10:00", title: "当事方否认", desc: "相关方表示未曾有过该段对话。", source: "公开声明" },
      { time: "09-05 14:00", title: "音频比对更新", desc: "环境音分析与直播音轨比对结果补充。", source: "本站复核" },
    ],
    evidence: [
      { type: "音频", title: "流传录音", desc: "时长约38秒，背景噪声被明显压制。", weight: "中", source: "公开传播" },
      { type: "音频比对", title: "直播音轨对比", desc: "同场直播存在持续环境底噪，流传录音中缺失。", weight: "中", source: "本站分析" },
      { type: "文字", title: "当事方回应", desc: "否认录音内容，但未提供当日完整行程。", weight: "弱", source: "公开声明" },
    ],
    credible: [
      "流传录音的背景底噪与环境声明显低于正常现场录音。",
      "录音中段存在一处不自然的能量断点。",
    ],
    disputed: [
      "现有工具无法完全排除强降噪带来的失真可能。",
      "缺少可对照的现场原始音轨，结论暂不完整。",
    ],
    verdict:
      "录音具备被处理过的特征，但还不能据此认定内容为虚假，判定为追证中。后续如能取得现场原始音轨，会更新判断。",
  },
  {
    id: "product-safety-claims",
    summary:
      "围绕一款热销产品的安全性出现多版本说法。我们整理了公开检测报告、配料表截图与商家回应，把能被验证与暂不能验证的部分分开列出。",
    timeline: [
      { time: "08-12 10:00", title: "质疑帖出现", desc: "有用户发布配料表对比截图并提出疑问。", source: "平台公开帖" },
      { time: "08-14 16:00", title: "检测报告被转发", desc: "一份检测报告截图开始流传，但缺少完整编号。", source: "平台转发" },
      { time: "08-18 11:00", title: "商家回应", desc: "商家公布完整配料表与部分检测信息。", source: "官方账号" },
      { time: "09-01 15:00", title: "分类整理完成", desc: "可验证与待验证内容被分开列出。", source: "本站复核" },
    ],
    evidence: [
      { type: "配料表", title: "包装配料表照片", desc: "与商家公布的文本内容一致。", weight: "强", source: "用户拍摄" },
      { type: "检测报告", title: "部分检测信息", desc: "报告缺少完整编号，无法核对出具机构。", weight: "弱", source: "平台转发" },
      { type: "说明", title: "商家完整配料说明", desc: "对成分来源作出解释。", weight: "中", source: "官方账号" },
      { type: "标准", title: "公开执行标准编号", desc: "产品包装标注的执行标准可在公开渠道检索到。", weight: "中", source: "公开检索" },
    ],
    credible: [
      "包装配料表与商家公布文本一致，这一点可以确认。",
      "产品标注的执行标准编号可在公开渠道检索到。",
    ],
    disputed: [
      "流传的检测报告缺少完整编号，无法确认出具机构与检测时间。",
      "个别成分的用量是否在合理区间，需要完整报告才能判断。",
    ],
    verdict:
      "配料表与执行标准部分可以确认；检测报告部分因信息不完整，暂无法采信。判定为追证中，待完整报告公开后再评估。",
  },
  {
    id: "old-photo-misread",
    summary:
      "一张被当作近期照片传播的图片，实际拍摄于数年前。我们通过同款服装的上市时间、背景店铺招牌与原始发布记录完成时间线还原。",
    timeline: [
      { time: "07-30 20:00", title: "照片开始传播", desc: "被配以「近日」字样在多个账号转发。", source: "平台公开帖" },
      { time: "08-02 10:00", title: "出现时间质疑", desc: "有用户指出照片背景店铺早已更换招牌。", source: "平台评论" },
      { time: "08-10 14:00", title: "找到更早记录", desc: "在旧相册中检索到同图更早的发布记录。", source: "公开存档" },
      { time: "08-22 16:00", title: "时间线还原完成", desc: "拍摄时间可确认为数年前。", source: "本站复核" },
    ],
    evidence: [
      { type: "照片", title: "原始照片", desc: "背景中的店铺招牌为旧版设计。", weight: "强", source: "公开存档" },
      { type: "记录", title: "更早发布记录", desc: "存在比本次传播早数年的同图发布。", weight: "强", source: "公开存档" },
      { type: "对照", title: "服装上市时间", desc: "照片中服装款的公开上市时间早于本次传播。", weight: "中", source: "公开信息" },
    ],
    credible: [
      "同图存在更早数年的发布记录，可以确定并非近期拍摄。",
      "背景店铺招牌与现状不符，支持旧照判断。",
    ],
    disputed: [
      "具体拍摄日期只能精确到年份范围。",
    ],
    verdict:
      "该照片并非近期拍摄，判定为已澄清。传播时所配的时间描述与事实不符，建议转发时注明原始时间。",
  },
  {
    id: "revenue-share-chat",
    summary:
      "双方就分成比例各执一词，各自公开了部分对话截图。由于截图均经过裁剪且缺少上下文，我们只标注可交叉验证的片段，不做定论。",
    timeline: [
      { time: "08-09 18:00", title: "一方公开截图", desc: "发布数张裁剪过的对话截图。", source: "公开帖" },
      { time: "08-11 12:00", title: "另一方回应", desc: "发布另一组截图，内容与前者部分冲突。", source: "公开帖" },
      { time: "08-16 09:00", title: "异议集中于上下文", desc: "双方均指出对方截图缺少前后文。", source: "平台评论" },
      { time: "08-29 17:00", title: "交叉验证完成", desc: "仅少数片段可被双方共同确认。", source: "本站复核" },
    ],
    evidence: [
      { type: "截图", title: "甲方截图x3", desc: "均经过裁剪，缺少时间戳。", weight: "弱", source: "公开帖" },
      { type: "截图", title: "乙方截图x2", desc: "内容与甲方部分重叠但顺序不同。", weight: "弱", source: "公开帖" },
      { type: "文字", title: "双方共同确认的片段", desc: "两条对话内容双方均未否认。", weight: "中", source: "双方发言" },
    ],
    credible: [
      "双方共同确认的两条对话内容可作为基础事实参考。",
    ],
    disputed: [
      "其余截图均缺少上下文与时间戳，无法还原完整对话。",
      "分成比例的具体数字，双方说法不一致且无第三方凭证。",
    ],
    verdict:
      "由于关键凭证缺失，判定为存疑。本站仅列出双方共同确认的片段，不采信任何一方的单方截图结论。",
  },
  {
    id: "ai-voice-clip",
    summary:
      "一段被指为本人发言的语音广泛传播。通过呼吸停顿、齿音细节与频谱比对，我们记录了判定为合成语音的几个关键依据。",
    timeline: [
      { time: "08-28 21:00", title: "语音首次出现", desc: "以文件形式在社群传出，未标注录制环境。", source: "社群音频" },
      { time: "08-29 15:00", title: "被指为本人发言", desc: "配以文字摘要开始大范围传播。", source: "平台公开帖" },
      { time: "09-02 10:00", title: "当事人否认", desc: "当事人表示未录制过该内容。", source: "公开声明" },
      { time: "09-07 14:00", title: "频谱比对完成", desc: "多处特征与合成语音一致。", source: "本站复核" },
    ],
    evidence: [
      { type: "音频", title: "流传语音文件", desc: "时长约52秒，采样率存在二次转码痕迹。", weight: "中", source: "公开传播" },
      { type: "音频比对", title: "呼吸停顿分析", desc: "长句之间缺少自然的换气停顿。", weight: "强", source: "本站分析" },
      { type: "音频比对", title: "频谱与齿音检查", desc: "高频细节在多个音节上呈现规律性缺失。", weight: "强", source: "本站分析" },
      { type: "文字", title: "当事人声明", desc: "否认为本人录制。", weight: "中", source: "公开声明" },
    ],
    credible: [
      "长句之间缺少自然换气停顿，与真人说话习惯不符。",
      "高频齿音细节在多个音节上呈现规律性缺失，符合合成语音特征。",
      "文件存在二次转码痕迹，采样参数与常规录音设备不符。",
    ],
    disputed: [
      "无法确认具体使用了哪一款语音合成工具。",
    ],
    verdict:
      "多项音频特征均指向合成语音，判定为已核实。建议在当事人未确认的情况下，不要将该内容作为真实发言引用。",
  },
];